











import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class L3FrameWithTitle extends Vue {
@Prop({ required: true }) title!: string;
}
